export const volumes = [
  {
    numeral: 'I',
    color: '#2F7BEA',
    title: 'The Arterial Blood Gas Foundations Guide',
    subtitle: 'Build a clear educational foundation before moving into more complex concepts.',
    intro:
      'I designed this volume to help you organize the essential terminology and physiological principles involved in arterial blood gas interpretation. Instead of studying isolated definitions, you’ll find a structured reference that introduces the measurements and concepts used throughout the collection.',
    items: [
      'Introduction to arterial blood gas testing',
      'Understanding pH and acid-base terminology',
      'PaCO₂ and respiratory physiology fundamentals',
      'Bicarbonate and its role in acid-base balance',
      'Introduction to oxygenation measurements',
      'Arterial blood gas abbreviations and terminology',
      'Reference intervals and their limitations',
      'Factors that influence laboratory measurements',
      'Understanding individual values versus broader physiological context',
      'Foundational knowledge checks and review exercises',
    ],
    takeaway:
      'A structured educational foundation for studying the principal ABG measurements and understanding the physiological concepts behind them.',
    note: '',
  },
  {
    numeral: 'II',
    color: '#E5394A',
    title: 'The Acid-Base Disorders Clinical Atlas',
    subtitle: 'Organize the differences between respiratory and metabolic acid-base disorders.',
    intro:
      'Acid-base interpretation becomes easier to study when the major concepts are presented in a consistent format. In this volume, I’ve organized the principal acid-base disorders into dedicated sections with comparison tables and educational explanations.',
    items: [
      'Fundamentals of acid-base homeostasis',
      'Understanding acidemia and alkalemia',
      'Respiratory acidosis concepts',
      'Respiratory alkalosis concepts',
      'Metabolic acidosis concepts',
      'Metabolic alkalosis concepts',
      'Primary acid-base disturbances',
      'Relationships between pH, PaCO₂, and HCO₃⁻',
      'Physiological mechanisms associated with different disorders',
      'Visual comparison tables',
      'Educational exercises for distinguishing acid-base patterns',
    ],
    takeaway:
      'An organized educational reference for studying the four major categories of acid-base disorders and the physiological principles that distinguish them.',
    note: '',
  },
  {
    numeral: 'III',
    color: '#12A150',
    title: 'The Step-by-Step ABG Interpretation Workbook',
    subtitle: 'Practice organizing ABG information through a consistent educational sequence.',
    intro:
      'Knowing what individual measurements represent is only one part of learning ABG interpretation. This volume provides a structured educational framework for examining the available information, comparing relevant measurements, and explaining your reasoning.',
    items: [
      'Reviewing the information provided in an educational case',
      'Examining pH in relation to acid-base status',
      'Studying PaCO₂ and its respiratory significance',
      'Reviewing HCO₃⁻ and its metabolic significance',
      'Comparing respiratory and metabolic patterns',
      'Organizing the possible primary disturbance',
      'Identifying missing information and contextual questions',
      'Understanding the limitations of simplified interpretation rules',
      'Worked educational examples',
      'Guided practice worksheets',
      'Answer explanations and self-assessment questions',
    ],
    takeaway:
      'A repeatable educational framework for organizing ABG exercises and explaining the reasoning behind your interpretations.',
    note: '',
  },
  {
    numeral: 'IV',
    color: '#8B5CF6',
    title: 'The Compensation & Mixed Disorders Study Guide',
    subtitle: 'Understand the concepts that make ABG interpretation more challenging.',
    intro:
      'Compensation and mixed acid-base disorders can introduce additional complexity when studying arterial blood gases. I created this volume to organize the underlying concepts through structured explanations, comparison tables, and educational examples.',
    items: [
      'Introduction to physiological compensation',
      'Respiratory responses to metabolic disturbances',
      'Renal responses to respiratory disturbances',
      'Acute and chronic respiratory acid-base concepts',
      'Expected compensation principles',
      'Introduction to mixed acid-base disorders',
      'Patterns that may suggest multiple primary disturbances',
      'Compensation formulas and their limitations',
      'Factors that influence acid-base measurements',
      'Educational comparison exercises',
      'Guided case studies with explanatory answers',
    ],
    takeaway:
      'A structured educational reference for studying compensation principles, understanding mixed-disorder concepts, and recognizing when a simplified explanation may be insufficient.',
    note: '',
  },
  {
    numeral: 'V',
    color: '#E39A0B',
    title: 'The ABG Reference Tables & Interpretation Pitfalls Manual',
    subtitle: 'Keep essential ABG concepts organized in one practical reference.',
    intro:
      'Sometimes you don’t need to reread an entire chapter. You need a concise reference that helps you revisit a specific concept. This volume brings together selected reference tables, terminology, comparison tools, and common conceptual pitfalls.',
    items: [
      'ABG terminology and abbreviation reference',
      'pH, PaCO₂, and HCO₃⁻ comparison tables',
      'Respiratory versus metabolic pattern summaries',
      'Acid-base disorder comparison matrix',
      'Compensation concept reference tables',
      'Oxygenation terminology and limitations',
      'Common conceptual misconceptions',
      'Measurement variability considerations',
      'Reference intervals and their limitations',
      'Questions to consider when information is incomplete',
      'Quick-review knowledge checks',
    ],
    takeaway:
      'An organized educational reference for reviewing key ABG concepts, comparing related patterns, and identifying topics that need further study.',
    note: '',
  },
  {
    numeral: 'VI',
    color: '#0EA5B7',
    title: 'The ABG Clinical Case Practice Collection',
    subtitle: 'Move beyond reviewing definitions and practice organizing ABG information.',
    intro:
      'One of the most useful ways to reinforce your learning is to work through educational cases that require you to apply the concepts you’ve studied. That’s why I included a dedicated collection of simulated cases and guided exercises.',
    items: [
      'Foundational ABG interpretation exercises',
      'Respiratory acid-base case scenarios',
      'Metabolic acid-base case scenarios',
      'Compensation-focused learning exercises',
      'Cases involving potentially mixed disturbances',
      'Examples with incomplete information',
      'Questions about contextual factors and measurement limitations',
      'Guided reasoning worksheets',
      'Self-assessment questions',
      'Suggested educational explanations and answer reviews',
    ],
    takeaway:
      'An opportunity to reinforce your understanding by organizing information, explaining your reasoning, and identifying concepts that deserve further study.',
    note: 'These scenarios are educational exercises, not validated clinical decision algorithms or substitutes for supervised clinical practice.',
  },
];
